import Skeleton from 'react-loading-skeleton';

export default function TransactionListLoader() {
  const transactionsSkeleton = Array.from({ length: 3 });
  return (
    <div className="flex flex-col gap-2x">
      {transactionsSkeleton.map((_, index) => (
        <div
          className={`flex flex-col gap-1x ${
            index !== transactionsSkeleton.length - 1
              ? 'border-b border-gray pb-2x'
              : ''
          }`}
          key={`wallet-loader-${index}`}
        >
          <div className="flex gap-2x items-center">
            <Skeleton width={120} height={14} />
            <Skeleton width={90} height={18} />
          </div>
          <Skeleton width={160} height={12} />
        </div>
      ))}
    </div>
  );
}
